import { useCallback, useRef } from 'react';

const DEFAULT_LEAVE_GUARD = () => true;

export const useLeaveGuard = () => {
  const leaveGuardRef = useRef(DEFAULT_LEAVE_GUARD);
  const allowNextNavigationRef = useRef(false);

  const registerLeaveGuard = useCallback(leaveGuard => {
    leaveGuardRef.current = leaveGuard || DEFAULT_LEAVE_GUARD;
  }, []);

  const getLeaveConfirmation = useCallback(() => leaveGuardRef.current(), []);

  const allowNextNavigation = useCallback(() => {
    allowNextNavigationRef.current = true;
  }, []);

  const getPromptMessage = useCallback(() => {
    if (allowNextNavigationRef.current) {
      allowNextNavigationRef.current = false;
      return true;
    }

    return getLeaveConfirmation();
  }, [getLeaveConfirmation]);

  const canDiscardCurrentSelection = useCallback(() => {
    const leaveConfirmation = getLeaveConfirmation();

    if (leaveConfirmation === true) return true;

    // eslint-disable-next-line no-alert
    return window.confirm(leaveConfirmation);
  }, [getLeaveConfirmation]);

  return {
    allowNextNavigation,
    canDiscardCurrentSelection,
    getPromptMessage,
    registerLeaveGuard
  };
};
